import { FileProviderViewState, getFileProviders } from 'owa-fileprovider-store';
import { FolderSelectorProviderType } from '../store/schema/FolderSelectorProviderType';
import { getStore } from '../store/store';

export function getSelectedProviderType() {
    return getStore().selectedProviderType;
}

export type FolderSelectorProviderViewState = FileProviderViewState & {
    type: FolderSelectorProviderType;
};

export function getSelectedProvider(): FolderSelectorProviderViewState | null {
    const fileProviders = getFileProviders();
    const selectedProviderType = getSelectedProviderType();

    const [selectedProvider] = fileProviders.filter(
        provider => provider.viewType === selectedProviderType
    );

    return (selectedProvider as FolderSelectorProviderViewState) || null;
}
